/** * 弹窗演示 * 徐杰 * 2019-4-22 **/
<template>
  <div>
    <X-Layout>
      <!-- 位置条 -->
      <div style="position: relative; display: flex; justify-content: space-between; height: 28px; line-height: 28px">
        <Breadcrumb>
          <BreadcrumbItem to="/home"> <Icon type="icon iconfont icon-xitong" /> 系统首页 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="icon iconfont icon-xitonghoutai" /> 系统管理 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="icon iconfont icon-bianma" /> 编码字典 </BreadcrumbItem>
        </Breadcrumb>
        <i-button class="refresh" size="small" type="success">
          <Icon title="刷新" class="icon" type="ios-refresh" @click="reload" />
        </i-button>
      </div>

      <!-- 内容区域 -->
      <Card style="margin-top: 12px">
        <!-- 搜索栏 -->
        <div class="optdiv">
          <div>
            <Button type="primary" @click="toAddCompany">
              <Icon type="md-add" style="position: relative; top: -0.125rem" />&nbsp;新增pro</Button
            >
            <!-- <i-input class="tabdiv"  size="large" :value.sync="value" placeholder="请输入企业名称" style="width: 300px"></i-input>

					<Button class="tabdiv"  type="primary"><Icon style="font-size: 1rem;position: relative;top: -0.125rem;" type="ios-search"/>&nbsp;搜索</Button> -->
          </div>
        </div>
        <!-- 数据表格 -->
        <i-table width="100%" :columns="columns2" :data="dictionlist" :loading="tbLoading" />
        <!-- 分页 -->
        <Page
          style="margin-top: 0.625rem"
          :current.sync="page"
          :page-size-opts="[20, 50, 100, 200, 500]"
          :page-size="row"
          show-total
          :total="total"
          show-sizer
          @on-change="onNextPage"
          @on-page-size-change="onPageSize"
        />
      </Card>

      <Modal v-model="modal1" title="删除提示" ok-text="确定删除" @on-ok="ok" @on-cancel="cancel">
        <Alert type="warning" show-icon>
          <template slot="desc"> 你确定要删除这个编码吗？你的删除可能会影响接受端程序出错的问题！ </template>
        </Alert>
      </Modal>
    </X-Layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modal1: false,
      listindex: '', // 删除数组中的第几个数据
      value: '',
      tbLoading: false, // 表格加载动画、
      editIndex: -1, // 编辑使用
      pronumber: '', // 编辑用编码
      value1: '', // 编辑用中文名称
      value2: '', // 编辑用中文名称
      value3: '', // 编辑用中文名称
      value4: '', // 编辑用中文名称
      value5: '', // 编辑用中文名称
      edit_unit: '', // 编辑用计量单位
      columns2: [
        {
          type: 'index',
          title: '序号',
          align: 'center',
          minWidth: 90,
          indexMethod: row => {
            return row._index + 1 + this.page * this.row - this.row;
          },
        },
        {
          title: '编号',
          align: 'center',
          minWidth: 100,
          render: (h, { row, index }) => {
            let edit;
            if (this.editIndex === index) {
              // 判断编辑序号是否等会当前行索引
              edit = [
                h('Input', {
                  style: {
                    width: '200px',
                  },
                  props: {
                    value: row.pronumber,
                  },
                  on: {
                    input: val => {
                      this.pronumber = val;
                    },
                  },
                }),
              ];
            } else {
              edit = row.pronumber;
            }
            return h('span', edit);
          },
        },
        {
          title: '标准值1',
          align: 'center',
          minWidth: 100,
          render: (h, { row, index }) => {
            let edit;
            if (this.editIndex === index) {
              // 判断编辑序号是否等会当前行索引
              edit = [
                h('Input', {
                  style: {
                    width: '200px',
                  },
                  props: {
                    value: row.values,
                  },
                  on: {
                    input: val => {
                      this.value1 = val;
                    },
                  },
                }),
              ];
            } else {
              edit = row.values;
            }
            return h('span', edit);
          },
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 220,
          align: 'center',
          render: (h, { row, index }) => {
            let edit;
            return h('div', [
              edit,
              h(
                'Icon',
                {
                  props: {
                    type: 'md-create',
                    title: '编辑',
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '20px',
                    cursor: 'pointer',
                  },
                  on: {
                    click: () => {
                      this.updata(row.pronumber);
                    },
                  },
                },
                '编辑',
              ),
              h(
                'Icon',
                {
                  props: {
                    type: 'ios-trash',
                    title: '删除',
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '20px',
                    cursor: 'pointer',
                    color: '#ed4014',
                  },
                  on: {
                    click: () => {
                      this.deldata(row.gk_pid);
                    },
                  },
                },
                '删除',
              ),
            ]);
          },
        },
      ],
      dictionlist: [], // 字典信息
      total: 0, // 总条数
      page: 1, // 当前页数
      row: 20,
    };
  },

  mounted() {
    this.getDictona(1);
  },
  methods: {
    // 获取编码字典
    getDictona(page) {
      const api = this.ApiUrl + 'gkPro/findAll';
      const params = {
        pageNo: page,
        pageSize: this.row,
      };
      this.tbLoading = true; // 开启加载动画
      this.$http.get(api, { params }).then(
        res => {
          if (res.data.extend.news === 0) {
            this.dictionlist = res.data.extend.pageInfo.records;
            this.total = res.data.extend.pageInfo.total;
            this.page = page;
          }
          this.tbLoading = false; // 关闭加载动画
        },
        res => {
          this.tbLoading = false; // 关闭加载动画
        },
      );
    },

    /** *
     * 确定删除
     */
    ok() {
      const api = this.ApiUrl + 'gkPro/delById';
      const data = {
        gk_pid: this.listindex,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            if (this.page > 1 && this.dictionlist.length == 1) {
              this.page -= 1;
            }
            this.getDictona(this.page);
            this.$Message.success('成功删除');
          } else {
            this.$Message.warning(res.data.extend.msg || '操作失败');
          }
        },
        res => {},
      );
    },
    /**
     * 编辑
     */
    updata(proid) {
      this.$router.push({
        name: 'updataPro',
        query: {
          proid: proid,
        },
      });
    },
    /**
     * 对话框 取消事件
     */
    cancel() {
      this.$Message.info('取消删除');
    },

    // 表格删除事件
    deldata(index) {
      this.modal1 = true;
      this.listindex = index;
    },
    // 编辑确认按钮
    editOK(id) {
      const api = this.ApiUrl + 'gkPro/updatePro';
      const data = {
        value5: this.value5,
        value4: this.value4,
        value3: this.value3,
        value2: this.value2,
        value1: this.value1,
        PRONumber: this.pronumber,
        gk_pid: id,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            this.$Message.success('修改成功!');
          } else {
            this.$Message.error('修改失败!');
          }
        },
        res => {},
      );
    },
    // 切换显示的页数
    onPageSize(e) {
      this.row = e;
      this.getDictona(1);
    },
    // 切换下一页
    onNextPage(e) {
      this.getDictona(e);
    },
    // 刷新页面
    reload() {
      location.reload();
    },
    /**
     * 点击确定事件1
     */
    clickOK1() {
      this.$Message.info('点击确认');
    },
    /**
     * 点击取消事件
     */
    clickCancel1() {
      this.$Message.info('点击取消');
    },
    /**
     * 删除事件
     */
    clickDel() {
      this.modal_loading = true; // 开启加载动画

      setTimeout(() => {
        this.modal_loading = false;
        this.modal2 = false;
        this.$Message.success('窗口隐藏');
      }, 2000);
    },

    /**
     * 跳转到添加企业
     */
    toAddCompany() {
      this.$router.push({
        name: 'addpro',
        params: {
          admid: 123,
        },
      });
    },
  },
};
</script>

<style scoped>
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  font-size: 1.5rem;
}

.refresh {
  float: right;
  margin-right: 1.25rem;
}

.optdiv {
  display: flex;
  padding: 0.625rem 0;
  justify-content: space-between;
}

.tabdiv {
  margin-left: 1.25rem;
}
</style>
